import React, { useState, useEffect } from 'react';
import {
  Button,
  Label,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from 'reactstrap';

/**
 * Modal to create or edit a model
 */
function ModelModal({
  title = 'Modelo',
  isOpen = false,
  onToggle = () => {},
  defaultModel = null,
  onSubmit = () => {},
}) {
  const [name, setName] = useState('');

  // Update form when defaultModel changes (for edit mode)
  useEffect(() => {
    if (defaultModel) {
      setName(defaultModel.name || '');
    } else {
      setName('');
    }
  }, [defaultModel]);

  const handleSubmit = () => {
    if (!name.trim()) return;
    onSubmit(name.trim());
    handleCancel(); // Close modal and reset form
  };

  const handleCancel = () => {
    // Reset form to original values
    if (defaultModel) {
      setName(defaultModel.name || '');
    } else {
      setName('');
    }
    onToggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={onToggle} size="md">
      <ModalHeader toggle={onToggle}>{title}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="modelName">Nombre del modelo</Label>
          <Input
            id="modelName"
            type="text"
            placeholder="Ingrese el nombre del modelo"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSubmit();
              }
            }}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleCancel}>
          Cancelar
        </Button>
        <Button color="primary" onClick={handleSubmit} disabled={!name.trim()}>
          {defaultModel ? 'Actualizar' : 'Crear'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModelModal;
